module.exports = "/_next/static/media/df9744b6ca988999f3c48a045b409d1d.png";